import { render, staticRenderFns } from "./cardV4.vue?vue&type=template&id=7ac0506a&scoped=true"
import script from "./cardV4.vue?vue&type=script&lang=js"
export * from "./cardV4.vue?vue&type=script&lang=js"
import style0 from "./cardV4.vue?vue&type=style&index=0&id=7ac0506a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0506a",
  null
  
)

export default component.exports